<template>
   <b-container>
      <b-row class="mt-5 text-center">
         <b-col>
            <div v-if="busy">
               <b-spinner/>
               <p class="mt-3">Signing you in…</p>
            </div>
            <div v-else-if="error">
               <h4 class="text-danger">Could not pair this device</h4>
               <p>{{ error }}</p>
               <p class="text-muted small">
                  The code may have expired or already been used. Please generate a new code on your other
                  device.
               </p>
               <b-button variant="primary" :to="{name: 'shopLogin'}">Back to login</b-button>
            </div>
         </b-col>
      </b-row>
   </b-container>
</template>

<script>
import {mapActions} from 'vuex';

export default {
   name: 'pair',
   data() {
      return {
         busy: true,
         error: null
      };
   },
   methods: {
      ...mapActions('account', ['loginWithPairingToken'])
   },
   created() {
      const token = this.$route.query.token;
      if (!token) {
         this.busy = false;
         this.error = 'Missing pairing token.';
         return;
      }

      this.loginWithPairingToken(token).then(() => {
         this.$router.replace('/');
      }).catch(() => {
         this.busy = false;
         this.error = 'This pairing code is invalid or has expired.';
      });
   }
};
</script>
